const postBookingUtils = require('./utils');
const findMatchingBaggageEntry = (list = [], baggageEntry = {}) => {
    let entry;
    if (baggageEntry.pieces === -1) {
        entry = list.find((e) => e.pieces === -1);
    } else {
        entry = list.find((e) => e.kilos === baggageEntry.kilos);
    }

    return entry || {};
};

const getBaggageEntryLabel = (bagEntry, keys) => {
    const hasWeight = bagEntry.kilos > 0 || bagEntry.isWeightConcept;
    const concept = hasWeight
        ? (bagEntry.pieces > 1 && Odigeo.AB.isDisplayTotalBaggageWeightAllowance
            ? keys.bagByTotalKilos
            : keys.bagByKilos)
        : keys.bagByPieces;
    const piecesPrefix = hasWeight && bagEntry.pieces > 1 && Odigeo.AB.isDisplayTotalBaggageWeightAllowance ? '' : bagEntry.pieces;
    const prefix = bagEntry.pieces > 0 ? piecesPrefix : keys.upTo + ' ';
    const suffix = Odigeo.Utils.pluralizeAll(concept, bagEntry.pieces, bagEntry.kilos);

    return `${prefix}${suffix}`;
};

module.exports = {
    getBaggageInfoFromBookingInfo(bookingInfo = {}, keys) {
        const baggagePerLeg = [];
        const travellers = bookingInfo.travellers || [];

        travellers.forEach((traveller) => {
            const travellerBaggageList = traveller.baggages || [];
            travellerBaggageList.reduce((acc, baggage, segmentIndex) => {
                const baggageDescriptionList = baggage.baggageDescriptionList || [];
                acc[segmentIndex] = acc[segmentIndex] || {
                    baggageList: [],
                    from: Object.assign({}, baggage.from),
                    to: Object.assign({}, baggage.to),
                };

                baggageDescriptionList.forEach((baggageEntry) => {
                    const entry = findMatchingBaggageEntry(acc[segmentIndex].baggageList, baggageEntry);
                    if (Odigeo._.isEmpty(entry)) {
                        entry.pieces = baggageEntry.pieces;
                        entry.kilos = baggageEntry.kilos;
                        entry.isWeightConcept = baggageEntry.pieces === -1;
                        acc[segmentIndex].baggageList.push(entry);
                    } else {
                        if (entry.isWeightConcept) {
                            entry.kilos += baggageEntry.kilos;
                        } else {
                            entry.pieces += baggageEntry.pieces;
                            if (baggageEntry.kilos > 0 && Odigeo.AB.isDisplayTotalBaggageWeightAllowance) {
                                entry.kilos += baggageEntry.kilos;
                            }
                        }
                    }

                    entry.label = getBaggageEntryLabel(entry, keys);
                });

                return acc;
            }, baggagePerLeg);
        });

        return baggagePerLeg;
    },

    haveAllTravellersAttachedInAllAvailableSegments(bookingInfo = {}) {
        const travellers = bookingInfo.travellers || [];
        let allAttachedInAllSegments = true;

        for (let i = 0; i < travellers.length && allAttachedInAllSegments; i++) {
            const traveller = travellers[i];
            const travellerBaggageList = traveller.baggages || [];

            allAttachedInAllSegments = travellerBaggageList.reduce((acc, baggage, segmentIndex) => {
                const baggageDescriptionList = baggage.baggageDescriptionList || [];
                return acc && baggageDescriptionList.length > 0;
            }, allAttachedInAllSegments);
        }

        return allAttachedInAllSegments;
    },

    weHaveCoverage(catalogueData) {
        const catalogue = Odigeo._.get(catalogueData, 'availableAncillariesOptionsDTO.ancillaryOptionsContainer.baggageResultsResponse', []);
        const aSelectableBaggage = catalogue.find((baggageResult) => {
            const baggageConditions = Odigeo._.get(baggageResult, 'baggageConditions', []);
            return !Odigeo._.isUndefined(baggageConditions.find((baggageCondition) => {
                return !Odigeo._.isEmpty(baggageCondition.selectableBaggage);
            }));
        });

        return !Odigeo._.isUndefined(aSelectableBaggage);
    },

    isAvailable(catalogueData, bookingInfo) {
        return !postBookingUtils.haveAnyFlightCancelled(bookingInfo)
            && this.weHaveCoverage(catalogueData)
            && postBookingUtils.remainsTimeToBookTheProduct(bookingInfo);
    },
};
